define('bizzabo/models/community/Query',['backbone'], function (Backbone) {

    var Query = Backbone.Model.extend({

        defaults: function() {
            return {
                sort: 'attending-status-change',
                'sort-order': 'desc',
                q: '',
                count: 20,
                offset: 0
            };
        }

    });

    return Query;
});
